export const bkrUrl = 'https://www.bkr.se/wp-json/wp/v2/app_page';
